export default "__VITE_ASSET__Ce1er7ud__"